import { useEffect, useState } from 'react';
import http from 'services/http';

/**
 * Banner de aviso de mensalidade exibido no topo do painel da banca.
 * A cor/estágio e a mensagem vêm calculados do backend (GET mensalidade/aviso),
 * conforme os dias-chave configurados na Central. Não renderiza nada quando não
 * há aviso (cobrança desligada ou banca já paga/desmarcada).
 */

// Cores do layout aprovado: fundo claro + borda no mesmo tom, texto escuro.
const ESTAGIOS = {
	cinza: { bg: '#ffffff', border: '#e4e6eb', icone: 'info' },
	amarelo: { bg: '#fdf6d8', border: '#f2e3a3', icone: 'alerta' },
	vermelho: { bg: '#fce8ea', border: '#f5c9cd', icone: 'alerta' },
};

const TEXTO = '#1f2328';

const IconeAlerta = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		stroke={TEXTO}
		strokeWidth="1.6"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
	>
		<path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
		<line x1="12" y1="9" x2="12" y2="13" />
		<line x1="12" y1="17" x2="12.01" y2="17" />
	</svg>
);

const IconeInfo = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		stroke={TEXTO}
		strokeWidth="1.6"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
	>
		<circle cx="12" cy="12" r="10" />
		<line x1="12" y1="16" x2="12" y2="12" />
		<line x1="12" y1="8" x2="12.01" y2="8" />
	</svg>
);

const AvisoMensalidade = () => {
	const [aviso, setAviso] = useState(null);
	const [fechado, setFechado] = useState(false);

	useEffect(() => {
		let ativo = true;

		http
			.get('mensalidade/aviso')
			.then((res) => {
				if (ativo) setAviso(res?.data?.data?.aviso ?? null);
			})
			.catch(() => {});

		return () => {
			ativo = false;
		};
	}, []);

	if (!aviso || fechado) return null;

	const estagio = ESTAGIOS[aviso.estagio] || ESTAGIOS.cinza;

	return (
		<div
			style={{
				...styles.wrapper,
				backgroundColor: estagio.bg,
				border: `1px solid ${estagio.border}`,
			}}
		>
			<div style={styles.left}>
				{estagio.icone === 'alerta' ? <IconeAlerta /> : <IconeInfo />}
				<span>{aviso.mensagem}</span>
			</div>

			<button type="button" aria-label="Fechar" onClick={() => setFechado(true)} style={styles.close}>
				&times;
			</button>
		</div>
	);
};

const styles = {
	wrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: 12,
		padding: '13px 18px',
		margin: '14px 24px 0',
		borderRadius: 8,
		fontSize: 15,
		color: TEXTO,
	},
	left: { display: 'flex', alignItems: 'center', gap: 10 },
	close: {
		background: 'none',
		border: 'none',
		padding: 0,
		fontSize: 22,
		lineHeight: 1,
		color: '#5f6368',
		cursor: 'pointer',
		opacity: 0.9,
	},
};

export default AvisoMensalidade;
